import { helper } from '@ember/component/helper';
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';

export default helper(function ([value]: [Date]): string {
  return formatDistanceToNow(value, { addSuffix: true });
});
